module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "info"
  }, [_c('nav', {
    staticClass: "info__nav"
  }, [_c('ul', {
    staticClass: "info__menu",
    class: {
      'info__menu_grow': _vm.isShrinkAndGrow
    }
  }, _vm._l((_vm.menuLinks), function(ref, index) {
    var name = ref.name;
    var path = ref.path;
    var meta = ref.meta;

    return _c('router-link', {
      key: index,
      staticClass: "info__item",
      class: {
        'info__item_info': meta.icon
      },
      attrs: {
        "tag": "li",
        "active-class": "info__item_active",
        "exact-active-class": "info__item_active",
        "to": {
          name: name
        }
      }
    }, [(meta.title) ? [(_vm.$route.meta.title !== meta.title) ? _c('a', {
      staticClass: "info__link"
    }, [_vm._v(_vm._s(meta.title))]) : _c('span', {
      staticClass: "info__link"
    }, [_vm._v(_vm._s(meta.title))])] : [(_vm.$route.meta.icon !== meta.icon) ? _c('a', {
      staticClass: "info__icon"
    }) : _c('span', {
      staticClass: "info__icon info__icon_opacity"
    })]], 2)
  }), 1)]), _c('div', {
    staticClass: "info__content"
  }, [_vm._t("default")], 2)])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-519b9dbe","hasScoped":true,"preserveWhitespace":false}!./node_modules/vue-loader/lib/template-compiler/preprocessor.js?engine=pug!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/pages/profile/blocks/menu/Menu.vue
// module id = 1728de03e18ac4df8b86
// module chunks = 89